class TextVerticalSlider {
  constructor() {
    this.verticalSliderContainer = document.querySelectorAll(
      ".text-vertical-slider .swiper-container"
    );

    if (this.verticalSliderContainer.length > 0) {
      Promise.all([
        import(/* webpackChunkName: "library-swiper" */ "swiper"),
        import(
          /* webpackChunkName: "library-swiper-modules" */ "swiper/modules" // eslint-disable-line
        ),
      ])
        .then(([{ default: Swiper }, { Navigation }]) => {
          Array.from(this.verticalSliderContainer).forEach((el) =>
            this.init(el, Swiper, Navigation)
          );
        })
        .catch((err) => console.log(err)); // eslint-disable-line
    }
  }

  /* eslint-disable class-methods-use-this, no-unused-vars */
  init(verticalSliderContainer, Swiper, Navigation) {
    const textVerticalSlider = new Swiper(verticalSliderContainer, {
      modules: [Navigation],

      // eslint-disable-line
      // Optional parameters
      direction: "vertical",
      loop: false,
      mousewheel: false,
      slidesPerView: 3,
      speed: 600,
      grabCursor: true,
      preventInteractionOnTransition: true,
      roundLengths: true,
      touchReleaseOnEdges: true,
      updateOnWindowResize: true,

      // Navigation arrows
      navigation: {
        nextEl: ".js-text-vertical-button-next",
        prevEl: ".js-text-vertical-button-prev",
      },

      breakpoints: {
        0: {
          noSwiping: false,
          allowSlidePrev: false,
          allowSlideNext: false,
          spaceBetween: 109,
        },

        577: {
          noSwiping: true,
          allowSlidePrev: true,
          allowSlideNext: true,
          spaceBetween: 49,
        },
      },
    });
  }
  /* eslint-enable class-methods-use-this, no-unused-vars */
}

export default TextVerticalSlider;
